import React from 'react';
import BackButton from './BackButton';
import SaveDraft from '../containers/SaveDraft';

const DraftActions = () => (
  <div className="layout layout--auto layout--small layout--middle">
    <div className="layout__item">
      <BackButton to="/engagement" />
    </div>
    <div className="layout__item">
      <SaveDraft />
    </div>
  </div>
);

export default DraftActions;
